import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 7a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2l0 -10","key":"svg-0"}],["path",{"d":"M9 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M9 12h-7","key":"svg-2"}],["path",{"d":"M15 12h7","key":"svg-3"}]]

const IconEPassport = createReactComponent('outline', 'e-passport', 'EPassport', __iconNode);

export default IconEPassport;